const events = () => {

  const modalTriggers = document.querySelectorAll('.rsvp-modal-trigger'),
        rsvpModal = document.querySelector('#rsvp-modal');
  if(modalTriggers && rsvpModal) {
    const rsvpModalClose = document.querySelector('#rsvp-modal-close');
    modalTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        rsvpModal.classList.add('open');
        setTimeout(function() {
          rsvpModal.style.opacity = '1';
        }, 10);
      });
    });
    rsvpModalClose.addEventListener('click', function(e) {
      e.preventDefault();
      rsvpModal.style.opacity = '0';
      setTimeout(function() {
        rsvpModal.classList.remove('open');
      }, 1000);
    });
  }
  // hide rsvp form if event is sold out
  if(rsvpModal) {
    const postId = rsvpModal.dataset.postId,
          rsvpFormWrap = rsvpModal.querySelector('#rsvp-form-wrap'),
          rsvpSoldOut = rsvpModal.querySelector('#rsvp-sold-out');
    fetch('/wp-content/themes/hermd/theme-functions/ajax/rsvp-count.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        post_id: postId
      }),
    })
    .then(function (result) {
      return result.json();
    })
    .then(function (data) {
      //console.log(data);
      if(data.ticket_status == 'sold out') {
        rsvpFormWrap.remove();
        rsvpSoldOut.style.display = 'block';
      }
    });
  }

}

export default events;